export default __webpack_public_path__ + "static/media/g.e9b42196.png";